import { connectedStore } from '../../store';
import getBlock from '../selectors/block';

const isGlobalBlock = (blockId) => {
  const store = connectedStore.get();
  const state = store.getState();

  const block = getBlock(state, blockId);

  return Boolean(block.global);
};

export default isGlobalBlock;
